import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import "animate.css/animate.min.css";
import 'spark-core-dx/sparkStartup';
import App from './App';
import configData from './config.json'
import { SparkReportWebVitals } from 'spark-core-dx';
import { BrowserRouter as Router, useNavigate } from 'react-router-dom';
import { CoreContextProvider, CoreStateContextProvider, AGALContextProvider } from 'spark-core-dx/contexts';
import { Theme } from 'spark-core-dx/components'
import { ItemServiceFactory as CurrentItemServiceFactory } from './services/ItemServiceFactory';
import { createPlatformUiCommandHandler } from './platformUiCommandHandler';

const rootElm = document.getElementById('root');
rootElm.classList.add("app");
const root = ReactDOM.createRoot(rootElm);
window.configData = configData;

const PlatformApplication = () => {
  const navigate = useNavigate();
  const uiCommandHandler = React.useMemo(
    () => createPlatformUiCommandHandler(navigate),
    [navigate]
  );

  return (
    <CoreStateContextProvider>
      <CoreContextProvider
        itemServiceFactory={new CurrentItemServiceFactory()}
        uiCommandHandler={uiCommandHandler}
      >
        <AGALContextProvider>
          <Theme
            onCustomIndex={async () => {
              await import('spark-core-dx/sparkIndex.css')
            }}
            onCustomSparkApp={async () => {
              await import('spark-core-dx/sparkApp.css')
            }} >
            <App />
          </Theme>
        </AGALContextProvider>
      </CoreContextProvider>
    </CoreStateContextProvider >
  );
};

root.render(
  <Router>
    <PlatformApplication />
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
SparkReportWebVitals();

//Extentions


